import { 
  collection, 
  addDoc, 
  updateDoc,
  doc, 
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../../config/firebase.js';

export const saveBook = async (bookData, userId) => {
  try {
    const docRef = await addDoc(collection(db, 'books'), {
      ...bookData,
      userId,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return { id: docRef.id, error: null };
  } catch (error) {
    return { id: null, error: error.message };
  }
};

export const updateBook = async (bookId, updates) => {
  try {
    const bookRef = doc(db, 'books', bookId);
    await updateDoc(bookRef, {
      ...updates,
      updatedAt: serverTimestamp()
    });
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};

export const getBook = async (bookId) => {
  try {
    const bookRef = doc(db, 'books', bookId);
    const bookSnap = await getDoc(bookRef);
    if (!bookSnap.exists()) {
      throw new Error('Book not found');
    }
    return { data: { id: bookSnap.id, ...bookSnap.data() }, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

export const getUserBooks = async (userId) => {
  try {
    const q = query(
      collection(db, 'books'),
      where('userId', '==', userId),
      orderBy('updatedAt', 'desc')
    );
    const snapshot = await getDocs(q);
    const books = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return { data: books, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};